function splitTrim(string, delim) {
    return string.split(delim)
        .map(it => it.trim());
}

function parseSpec(curr) {
    const [userSegment, licsSegment] = splitTrim(curr.replace(/]/, ""), "[");
    const [user, org] = userSegment.split(":");
    const licenses = licsSegment.split(",")
        .map(l => {
            const [path, perms] = splitTrim(l.replace(/\)/, ""), "(");
            const chain = splitTrim(path, ">");
            let impl;
            if (chain[0].indexOf(":") < 0) {
                impl = chain[0];
                chain[0] = org;
            } else {
                const [i, o] = splitTrim(chain[0], ":");
                impl = i;
                chain[0] = o;
            }
            return {
                impl,
                chain,
                perms: perms
                    ? splitTrim(perms, "|")
                    : undefined,
            };
        });

    const map = new Map();
    for (const l of licenses) {
        if (!map.has(l.impl)) {
            map.set(l.impl, {
                name: l.impl,
                implementer: l.chain[l.chain.length - 1],
                kids: new Map(),
            });
        }
        const path = l.chain
            .slice()
            .reverse();
        path
            .reduce((it, o) => {
                if (!it.kids.has(o)) {
                    it.kids.set(o, {
                        name: o,
                        kids: new Map(),
                    });
                }
                return it.kids.get(o);
            }, map.get(l.impl))
            .perms = l.perms;
    }

    function walk(it) {
        return {
            ...it,
            kids: [...it.kids.values()].map(walk),
        };
    }

    const forestUpdater = f => f.map(it => {
        if (map.has(it.name)) {
            const l = map.get(it.name);
            map.delete(it.name);
            return walk(l);
        } else {
            return {
                ...it,
                kids: [],
            };
        }
    }).concat([...map.values()].map(walk));

    return [user, org, forestUpdater];
}

export default parseSpec;



// WEBPACK FOOTER //
// ./app/lib/reauth/parseSpec.js